import React from "react";
import AddGalleryPieceContainer from "../containers/add-gallery-piece-container";

const AddGalleryPiecePage = () => (
  <main className="add-gallery-piece">
    <AddGalleryPieceContainer />
  </main>
);

export default AddGalleryPiecePage;
